module.exports = __webpack_public_path__ + "static/media/diagonal-lines.754be2fc.svg";